export class Configuration {
    number_of_week_visible_in_advance: number;
    number_of_week_visible_in_precedence: number;
    msg_confirm_week: string;
    showBadgeFrom: number;
    type_leave: string[];
    url_privacy: string;
    label_privacy: string;
    canSeeAllLeaveDetails: any;
}


// WEBPACK FOOTER //
// ./src/model/Configuration.ts